import { render, staticRenderFns } from "./OrderSettings.vue?vue&type=template&id=ad4545a0&"
import script from "./OrderSettings.vue?vue&type=script&lang=js&"
export * from "./OrderSettings.vue?vue&type=script&lang=js&"
import style0 from "./OrderSettings.vue?vue&type=style&index=0&id=ad4545a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports